module.exports = __webpack_public_path__ + "img/q_42_sor.023fdbfb.png";